/**
 * Description  :
 * Version      : 1.0.0
 * Author       : Luoye
 * Date         : 2024-06-03 17:03:07
 * LastEditors  : Luoye
 * FilePath     : /partner_web/src/common/utils/request.ts
 * Copyright (C) 2024 rose. All rights reserved.
 */
import { handleReqURl } from '../config/index';
import { noticeError } from 'SRC/common/utils/notification';
interface IData {
  [propName: string]: any;
}

type PostDataOptions = {
  signal?: AbortSignal;
  headers?: Record<string, string>;
};

export function postData(
  url: string,
  data: IData,
  isShowLoading?: boolean,
  selfHandle?: boolean,
  options?: PostDataOptions
) {
  const optionsData = options || {};
  const { signal } = optionsData;
  const myUrl = handleReqURl(url);
  const showLoadImgFlag = isShowLoading || false;
  return new Promise((resolve, reject) => {
    if (showLoadImgFlag) {
      // message.$loadingShow();
    }
    fetch(myUrl, {
      body: JSON.stringify(data), // must match 'Content-Type' header
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'include', // include, same-origin, *omit
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      redirect: 'follow', // manual, *follow, error
      referrer: 'no-referrer', // *client, no-referrer
      signal,
    })
      .then((response) => {
        if (!response.ok) {
          noticeError(`请求失败，状态码: ${response.status}`);
          return reject(`请求失败，状态码: ${response.status}`);
        }
        if (selfHandle) {
          return response.json().then((res) => resolve(res));
        }
        return response.json().then((res) => {
          resolve(res);
        });
      })
      .catch((e) => {
        reject(JSON.stringify(e));
      });
  });
}

export function getData(
  url: string,
  data?: IData,
  isShowLoading?: boolean,
  selfHandle?: boolean
) {
  const myUrl = handleReqURl(url, data);
  const showLoadImgFlag = isShowLoading || false;
  return new Promise((resolve, reject) => {
    if (showLoadImgFlag) {
      // message.$loadingShow();
    }
    fetch(myUrl, {
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'include', // include, same-origin, *omit
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      redirect: 'follow', // manual, *follow, error
      referrer: 'no-referrer', // *client, no-referrer
    })
      .then((response) => {
        if (!response.ok) {
          noticeError(`请求失败，请刷新页面，状态码: ${response.status}`);
          return reject(`请求失败，状态码: ${response.status}`);
        }
        if (selfHandle) {
          return response.json().then((res) => resolve(res));
        }
        return response.json().then((res) => {
          resolve(res);
        });
      })
      .catch((e) => {
        noticeError(`请求失败，请刷新页面`);
        reject(JSON.stringify(e));
      });
  });
}
